// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.warning-strip {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: var(--ods-color-gray-10);
  height: 3.125rem;
  border-bottom: 5px solid var(--ods-color-purple-60);
  max-width: 40.625rem;
  margin: 5% auto;
}
.warning-strip .icon {
  font-size: 1.375rem;
  font-weight: 700;
  flex-wrap: nowrap;
  align-self: center;
  align-content: flex-start;
  margin-left: 1.5625rem;
}
.warning-strip .icon img {
  width: 1.875rem;
}
.warning-strip .warning-message {
  font-weight: 600;
  margin-left: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/sign-out/sign-out.component.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,mDAAA;EACA,oBAAA;EACA,eAAA;AAAF;AAEE;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;AAAJ;AAEI;EACE,eAAA;AAAN;AAIE;EACE,gBAAA;EACA,iBAAA;AAFJ","sourcesContent":["\n.warning-strip {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  background-color: var(--ods-color-gray-10);\n  height: 3.125rem;\n  border-bottom: 5px solid var(--ods-color-purple-60);\n  max-width: 40.625rem;\n  margin: 5% auto;\n\n  .icon {\n    font-size: 1.375rem;\n    font-weight: 700;\n    flex-wrap: nowrap;\n    align-self: center;\n    align-content: flex-start;\n    margin-left: 1.5625rem;\n\n    img {\n      width: 1.875rem;\n    }\n  }\n\n  .warning-message {\n    font-weight: 600;\n    margin-left: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
